// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__DDMD3","cross":"Popup_cross__5pFMW","shake":"Popup_shake__TtTPT","thanking":"Popup_thanking__wMtHC","innerbox":"Popup_innerbox__8aKLs"};